var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.6C12.6451 15.6 15.6 12.6451 15.6 9C15.6 5.35492 12.6451 2.4 9 2.4C5.35492 2.4 2.4 5.35492 2.4 9C2.4 12.6451 5.35492 15.6 9 15.6ZM9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
    fill: "#00806A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.319 7.1818C12.4947 7.35754 12.4947 7.64246 12.319 7.8182L8.56899 11.5682C8.39327 11.7439 8.10839 11.7439 7.93265 11.5683L5.68186 9.31825C5.50609 9.14255 5.50604 8.85762 5.68175 8.68186C5.85745 8.50609 6.14238 8.50604 6.31814 8.68175L8.25073 10.6137L11.6826 7.1818C11.8583 7.00607 12.1433 7.00607 12.319 7.1818Z",
    fill: "#00806A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeConfirmed);
export default __webpack_public_path__ + "static/media/NoticeConfirmed.50f24a1ec20c76afa545367d4ffaaeaa.svg";
export { ForwardRef as ReactComponent };